import withResponsive from '../hoc/withResponsive'

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default withResponsive({
  name: 'header',

  componentDidMount () {
    window.addEventListener('resize', this.resize)
    setTimeout(this.resize, 1000)

    this.body = document.querySelector('body')
    this.menuLevel1 = this.el.querySelectorAll('.header-menu--level1')
    this.menuLevel2 = this.el.querySelectorAll('.header-menu--level2')
    this.submenuWrapper = this.el.querySelector('.submenu__wrapper')
    this.submenuLevel1 = this.submenuWrapper.querySelectorAll('.submenu')

    if (window.isIE11) {
      const subHerader = this.el.querySelector('.app-subheader')
      subHerader.classList.add('relative')
      subHerader.classList.remove('sticky')
    }

    Array.prototype.forEach.call(this.submenuLevel1, (subel, y) => {
      subel.classList.add('has-transitions')
    })

    Array.prototype.forEach.call(this.menuLevel1, (el, i) => {
      el.addEventListener('click', e => {
        Array.prototype.forEach.call(this.menuLevel1, (supel, i) => {
          supel.classList.remove('is-active')
        })

        const relSubmenu = this.submenuLevel1[i]
        if (relSubmenu) {
          if (relSubmenu.hasChildNodes()) e.preventDefault()

          relSubmenu.classList.toggle('is-active')

          Array.prototype.forEach.call(this.submenuLevel1, (subel, y) => {
            if (subel !== relSubmenu) subel.classList.remove('is-active')
          })

          if (relSubmenu.classList.contains('is-active')) {
            el.classList.add('is-active')
            if (relSubmenu.hasChildNodes()) {
              this.openSubmenu()
            } else {
              this.closeSubmenu()
            }
          } else {
            this.closeSubmenu()
          }
        }
      })
    })

    Array.prototype.forEach.call(this.menuLevel2, (el, i) => {
      el.addEventListener('mouseover', e => {
        if (!el.classList.contains('is-active')) {
          Array.prototype.forEach.call(this.menuLevel2, (el, i) => {
            el.classList.remove('is-active')
          })
          el.classList.add('is-active')
        }
      })

      const menuLevel3 = el.querySelectorAll('.header-menu--level3')

      Array.prototype.forEach.call(menuLevel3, (elt, i) => {
        elt.addEventListener('mouseover', e => {
          if (!elt.classList.contains('is-active')) {
            Array.prototype.forEach.call(menuLevel3, (el, i) => {
              el.classList.remove('is-active')
            })
            elt.classList.add('is-active')

            const submenuInfos = elt
              .closest('.submenu__content')
              .querySelector('.submenu__infos__wrapper')
              .querySelectorAll('.submenu__infos')
            const activeSubmenuInfo = submenuInfos[i]

            if (!activeSubmenuInfo.classList.contains('is-active')) {
              Array.prototype.forEach.call(submenuInfos, (smi, i) => {
                smi.classList.remove('is-active')
              })
              activeSubmenuInfo.classList.add('is-active')
            }
          }
        })
      })
    })

    this.mobileMenu = this.el.querySelector('.mobile-menu')

    this.mobileMenu.classList.add('has-transition')

    this.burger = this.el.querySelector('.hamburger')
    this.burger.addEventListener('click', () => {
      this.burger.classList.toggle('is-active')
      this.mobileMenu.classList.toggle('is-active')
    })

    document.onkeydown = evt => {
      evt = evt || window.event
      if (evt.keyCode === 27) {
        this.el.querySelector('.header-menu--level1.is-active').click()
        // this.closeSubmenu()
      }
    }
  },

  openSubmenu () {
    this.submenuWrapper.classList.add('is-active')
    this.body.classList.add('no-scroll-y')
  },

  closeSubmenu () {
    this.submenuWrapper.classList.remove('is-active')
    this.body.classList.remove('no-scroll-y')
  },

  resize () {
    // console.log('resize', document.querySelector('.app-body').offsetHeight)
    this.h = document.querySelector('.app-body').offsetHeight
    this.el.style.height = `${this.h}px`
  },
})
